<template>
  <div>
    <b-icon
      v-for="(star, index) in 5"
      :key="index"
      :icon="getStarIcon(index)"
      style="color: #ffd700; width: 1em; height: 1em"
    />
  </div>
</template>

<script>
export default {
  props: {
    rating: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getStarIcon(index) {
      const fullStars = Math.floor(this.rating);
      const hasHalf = this.rating % 1 >= 0.5;

      if (index < fullStars) return "star-fill";
      if (index === fullStars && hasHalf) return "star-half";
      return "star";
    },
  },
};
</script>
